export class AdjustLoyaltyShopCreditsRequest {
  Customer: number;
  OrderId: number;
  Credits: number;
  Remarks: string;
  User: string;
}